const cached = <Options, Formatter>(build: (locale: string, options?: Options) => Formatter) => {
  const formatters = new Map<string, Formatter>();
  return (locale: string, options?: Options): Formatter => {
    const key = `${locale}|${JSON.stringify(options ?? {})}`;
    const existing = formatters.get(key);
    if (existing) return existing;
    const formatter = build(locale, options);
    formatters.set(key, formatter);
    return formatter;
  };
};

export const numberFormat = cached(
  (locale: string, options?: Intl.NumberFormatOptions) => new Intl.NumberFormat(locale, options),
);

export const dateTimeFormat = cached(
  (locale: string, options?: Intl.DateTimeFormatOptions) =>
    new Intl.DateTimeFormat(locale, options),
);

export const relativeTimeFormat = cached(
  (locale: string, options?: Intl.RelativeTimeFormatOptions) =>
    new Intl.RelativeTimeFormat(locale, options),
);
